// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-36-wzw-43-tg-035-nto-0-uf-77-gmyqy-1-oiunu-2-qhhmly-7-ylqhei-js": () => import("./../../../src/pages/36wzw43tg035nto0uf77gmyqy1oiunu2qhhmly7ylqhei.js" /* webpackChunkName: "component---src-pages-36-wzw-43-tg-035-nto-0-uf-77-gmyqy-1-oiunu-2-qhhmly-7-ylqhei-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-using-typescript-tsx": () => import("./../../../src/pages/using-typescript.tsx" /* webpackChunkName: "component---src-pages-using-typescript-tsx" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */)
}

